const createReducer = type => (state = null, action) =>
  action.type === type ? action.payload : state;

export const reducers = {
  templateName: createReducer('CHANGE_TEMPLATE_NAME'),
  templateIcon: createReducer('CHANGE_TEMPLATE_ICON'),
  templateIconUrl: createReducer('SET_TEMPLATE_ICON_URL'),

  pointsPerPlay: createReducer('SET_POINTS_PER_PLAY'),
  pointsPerWin: createReducer('SET_POINTS_PER_WIN'),
};
